









import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDialog from '@core/components/AppDialog.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import AddPolicyIndividual from './model/AddPolicyIndividualDTO'
import { AddPolicyIndividualDTO } from '../../api'

@Component({
  components: {
    AppDialog,
    AppForm
  }
})
export default class TheAddPolicyIndividualModal extends Vue {
  @Prop() private addIndividual: AddPolicyIndividualDTO
  @Prop({ default: () => [] }) private clientList
  @Prop({ default: () => [] }) private rolesOption

  get clientListForSelection () {
    if (this.clientList.length === 0) {
      return [
        { label: '', value: '' }
      ]
    }
    return this.clientList.map(client => {
      return {
        label: `${client.name} (${client.clientId ? client.clientId : 'unknown'})`,
        value: client.oid
      }
    }).sort((a, b) => a.label.localeCompare(b.label)) // sort alphabetically by name
  }

  get addPolicyIndividualStructure (): FormStructure<AddPolicyIndividual> {
    return [
      {
        label: 'Entity / Individual',
        key: 'clientOid',
        options: this.clientListForSelection
      },
      {
        label: 'Roles',
        key: 'roles',
        type: 'multi',
        options: this.rolesOption
      }
    ]
  }
}
